export const REGULATORY_DIRECTORY_ENTITY_NOT_FOUND =
  'REGULATORY_DIRECTORY_ENTITY_NOT_FOUND';
export const REGULATORY_DIRECTORY_CANDIDATE_NOT_FOUND =
  'REGULATORY_DIRECTORY_CANDIDATE_NOT_FOUND';
export const REGULATORY_DIRECTORY_INVALID_STATE =
  'REGULATORY_DIRECTORY_INVALID_STATE';
export const REGULATORY_DIRECTORY_MERGE_IDENTITY_MISMATCH =
  'REGULATORY_DIRECTORY_MERGE_IDENTITY_MISMATCH';
export const REGULATORY_DIRECTORY_LINK_CONFLICT =
  'REGULATORY_DIRECTORY_LINK_CONFLICT';
export const REGULATORY_DIRECTORY_IDENTITY_IMMUTABLE =
  'REGULATORY_DIRECTORY_IDENTITY_IMMUTABLE';
export const REGULATORY_DIRECTORY_PLATFORM_PERMISSION_REQUIRED =
  'REGULATORY_DIRECTORY_PLATFORM_PERMISSION_REQUIRED';

export const regulatoryDirectoryErrorCodes = [
  REGULATORY_DIRECTORY_ENTITY_NOT_FOUND,
  REGULATORY_DIRECTORY_CANDIDATE_NOT_FOUND,
  REGULATORY_DIRECTORY_INVALID_STATE,
  REGULATORY_DIRECTORY_MERGE_IDENTITY_MISMATCH,
  REGULATORY_DIRECTORY_LINK_CONFLICT,
  REGULATORY_DIRECTORY_IDENTITY_IMMUTABLE,
  REGULATORY_DIRECTORY_PLATFORM_PERMISSION_REQUIRED,
] as const;
